(function (window) {
    //<editor-fold desc="Cookie">
    window.getCookie = function (name) {
        let ret = '';
        const cookies = document.cookie.split(';');
        for (const cookie of cookies) {
            const cookieValue = cookie.trim().split('=');
            if (cookieValue[0] === name) {
                if (cookieValue[1]) {
                    ret = cookieValue[1];
                    break;
                }
            }
        }
        return ret;
    }
    //</editor-fold>
}(window));
document.addEventListener('DOMContentLoaded', () => {
    // Light switcher
    const lightSwitches = document.querySelectorAll('.light-switch');
    if (lightSwitches.length > 0) {
        lightSwitches.forEach((lightSwitch, i) => {
            if (localStorage.getItem('dark-mode') === 'true') {
                lightSwitch.checked = true;
            }
            lightSwitch.addEventListener('change', () => {
                const {checked} = lightSwitch;
                lightSwitches.forEach((el, n) => {
                    if (n !== i) {
                        el.checked = checked;
                    }
                });
                document.documentElement.classList.add('[&_*]:!transition-none');
                if (lightSwitch.checked) {
                    document.cookie = "dark-mode=dark;path=/;max-age=32000000;";
                    document.documentElement.classList.add('dark');
                    document.querySelector('html').style.colorScheme = 'dark';
                    localStorage.setItem('dark-mode', 'true');
                    document.dispatchEvent(new CustomEvent('darkMode', {detail: {mode: 'on'}}));
                } else {
                    document.cookie = "dark-mode=light;path=/;max-age=32000000;";
                    document.documentElement.classList.remove('dark');
                    document.querySelector('html').style.colorScheme = 'light';
                    localStorage.setItem('dark-mode', 'false');
                    document.dispatchEvent(new CustomEvent('darkMode', {detail: {mode: 'off'}}));
                }
                setTimeout(() => {
                    document.documentElement.classList.remove('[&_*]:!transition-none');
                }, 1);
            });
        });
    }
    if (localStorage.getItem('dark-mode') === 'true') {
        if (getCookie('dark-mode') !== 'dark') {
            document.cookie = "dark-mode=dark;path=/;max-age=32000000;";
        }
    } else {
        if (getCookie('dark-mode') === 'dark') {
            document.cookie = "dark-mode=light;path=/;max-age=32000000;";
        }
    }
    // dark mode
    if (localStorage.getItem('dark-mode') === 'false' || !('dark-mode' in localStorage)) {
        document.querySelector('html').classList.remove('dark');
        document.querySelector('html').style.colorScheme = 'light';
    } else {
        document.querySelector('html').classList.add('dark');
        document.querySelector('html').style.colorScheme = 'dark';
    }

    // dark mode on key (Alt + L)
    window.addEventListener('keydown', (event) => {
        if (event.key === 'l' && event.altKey && ! event.ctrlKey && ! event.shiftKey) {
            const lightSwitches = document.querySelectorAll('.light-switch');
            if (lightSwitches.length > 0) {
                lightSwitches[0].click();
            }
        }
    });
});
